import React, { PropsWithChildren, useCallback, useContext, useRef } from 'react';

import { CustomBottomSheetModalProvider } from '@/feature/alerts/components/CustomBottomSheetModalProvider';
import { SelectionParam } from '@/feature/betslip-sbk/types';

import { PicksNotAddedModal, PicksNotAddedModalRef } from './PicksNotAddedModal';

type PicksNotAddedModalContextType = {
    showPicksNotAddedModal: (selections: SelectionParam[]) => void;
    dismissPicksNotAddedModal: () => void;
};

const PicksNotAddedModalContext = React.createContext<PicksNotAddedModalContextType | null>(null);

export const PicksNotAddedModalProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const modalRef = useRef<PicksNotAddedModalRef>(null);

    const showPicksNotAddedModal = useCallback((selections: SelectionParam[]) => {
        modalRef.current?.show(selections);
    }, []);

    const dismissPicksNotAddedModal = useCallback(() => {
        modalRef.current?.dismiss();
    }, []);

    return (
        <CustomBottomSheetModalProvider>
            <PicksNotAddedModalContext.Provider value={{ showPicksNotAddedModal, dismissPicksNotAddedModal }}>
                {children}
                <PicksNotAddedModal ref={modalRef} />
            </PicksNotAddedModalContext.Provider>
        </CustomBottomSheetModalProvider>
    );
};

export const usePicksNotAddedModal = () => {
    const context = useContext(PicksNotAddedModalContext);
    if (!context) {
        throw new Error('usePicksNotAddedModal must be used within a PicksNotAddedModalProvider');
    }
    return context;
};
